var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed inset-0 h-screen w-screen bg-black/30 z-2222 flex items-center justify-center"},[_c('spinner',{staticClass:"h-20 w-20"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }